var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classes,attrs:{"uk-alert":_vm.type==='alert'}},[_c('span',{staticClass:"uk-margin-small-right uk-icon",attrs:{"uk-icon":_vm.icon}}),_c('div',{staticClass:"text"},[_vm._t("default")],2),_c('div',{staticClass:"actions"},[_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }